// Ported from design/project/App54-OnBreak.dc.html, then wired: a break the player chose, or one staff started.
// Battles and deposits wait; withdrawing is the first thing on the screen.
import { useEffect, useState } from "react";
import { api } from "../api.js";
import { useGame, useTicker } from "../game.js";
import { go } from "../router.js";
import type { LimitsView } from "./App58-PlayLimits.js";

export function App54_OnBreak() {
  const { me } = useGame();
  const [view, setView] = useState<LimitsView | null>(null);
  useEffect(() => void api<LimitsView>("/v1/limits").then(setView).catch(() => {}), []);
  useTicker(1000);
  const b = view?.break;
  // The break ended while the screen was open: back to the game.
  useEffect(() => {
    if (view && !b) go("App09", true);
  }, [view, b]);
  const left = b ? Math.max(0, b.until - Date.now()) : 0;
  const days = Math.floor(left / 86_400_000);
  const hm = `${String(Math.floor((left % 86_400_000) / 3_600_000)).padStart(2, "0")}:${String(Math.floor((left % 3_600_000) / 60_000)).padStart(2, "0")}`;
  return (
    <div className="screen">
      <div className="orbL" aria-hidden="true" style={{ top: "40px", left: "-45px", width: "480px", height: "480px", background: "radial-gradient(circle, rgba(138,124,255,0.22) 0%, rgba(138,124,255,0) 62%)" }}></div>
      <div className="pad squeeze" style={{ height: "100%", paddingBottom: "calc(var(--dd-safe-bottom, 0px) + 20px)" }}>
        <div className="top"><span className="chip chipN">BREAK ACTIVE</span></div>
        <div style={{ marginTop: "14px", display: "flex", justifyContent: "center", flexShrink: 0 }}>
          <div style={{ width: "88px", height: "88px", borderRadius: "28px", background: "rgba(138,124,255,0.12)", border: "1px solid rgba(138,124,255,0.45)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 50px rgba(138,124,255,0.25)" }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#8A7CFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"></path></svg>
          </div>
        </div>
        <h1 className="h1" style={{ marginTop: "22px", textAlign: "center" }}>You're on a break</h1>
        <p className="muted" style={{ margin: "8px 6px 0", textAlign: "center", fontSize: "14px", lineHeight: "21px" }}>
          {b?.byStaff ? "Your account is on a break from battling." : "You chose a break."} Battles and deposits are paused until it ends.
        </p>
        <div className="g" style={{ marginTop: "20px", borderRadius: "20px", padding: "14px", display: "flex", flexDirection: "column", alignItems: "center", gap: "4px", flexShrink: 0 }}>
          <span className="lbl" style={{ fontSize: "10px" }}>BREAK ENDS IN</span>
          <span className="mono" role="timer" style={{ fontWeight: "800", fontSize: "32px" }}>{b ? `${days ? `${days}d ` : ""}${hm}` : "..."}</span>
          <span className="muted" style={{ fontSize: "12px" }}>{b?.byStaff ? "Questions? Message support" : "Breaks can't be ended early"}</span>
        </div>
        <div className="g row" style={{ marginTop: "12px", borderRadius: "18px", padding: "12px 14px", flexShrink: 0 }}>
          <span style={{ display: "flex", flexDirection: "column", gap: "2px" }}><span className="lbl" style={{ fontSize: "10px" }}>BATTLE BALANCE</span><span className="mono" style={{ fontWeight: "800", fontSize: "18px" }}>{me?.balance.available ?? "..."} USDT</span></span>
          <span className="chip" style={{ background: "rgba(204,255,0,0.12)", border: "1px solid rgba(204,255,0,0.4)", color: "#CCFF00" }}>WITHDRAW ANYTIME</span>
        </div>
        <div style={{ marginTop: "auto", paddingTop: "14px", display: "flex", flexDirection: "column", gap: "10px", flexShrink: 0 }}>
          <button onClick={() => go("App40")} className="btnP">WITHDRAW BALANCE</button>
          <button onClick={() => go("App09", true)} className="btnS">Back to the lobby</button>
        </div>
      </div>
    </div>
  );
}
